const TOGGLE_RENAMING_LIST = "SET_RENAMING_LIST";
const TOOGLE_DELETING_LIST = "TOOGLE_DELETING_LIST";
const TOOGLE_CREATING_LIST = "TOOGLE_CREATING_LIST";
const TOOGLE_CREATING_TODO = "TOOGLE_CREATING_TODO";
const TOGGLE_SHOWING_ALL_TODOS = "TOGGLE_SHOWING_ALL_TODOS";
const SWITCH_ACTIVE_TODOLIST_ID = "SWITCH_ACTIVE_TODOLIST_ID";
const SWITCH_VISIBLE_COMPLETED = "SWITCH_VISIBLE_COMPLETED";
const SWITCH_VISIBLE_IMPORTANT = "SWITCH_VISIBLE_IMPORTANT";
const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
const TOOGLE_IS_SEARCHING = "TOOGLE_IS_SEARCHING";

export { 
    SWITCH_ACTIVE_TODOLIST_ID, 
    TOOGLE_CREATING_TODO, 
    TOOGLE_CREATING_LIST, 
    TOOGLE_DELETING_LIST, 
    SWITCH_VISIBLE_COMPLETED, 
    SWITCH_VISIBLE_IMPORTANT, 
    SET_SEARCH_QUERY, 
    TOGGLE_SHOWING_ALL_TODOS,
    TOOGLE_IS_SEARCHING,
    TOGGLE_RENAMING_LIST };
